import React, { useEffect, useRef } from 'react';
import { Header, Title, Subtitle, Rings, RingMiddle, RingInner } from './StepHeader.styles';

/** Three concentric lime circles with an icon (success hero, WhatsApp, etc.). */
export const ConcentricIcon = ({ icon, size = 72, celebrate = false, tone }) => (
    <Rings ringSize={size} aria-hidden="true">
        <RingMiddle celebrate={celebrate}>
            <RingInner tone={tone} iconSize={Math.round(size * 0.32)}>
                <i className={icon} />
            </RingInner>
        </RingMiddle>
    </Rings>
);

/**
 * Step title (h1) + subtitle. On mount the h1 receives focus so screen readers announce the new
 * step, and the page scrolls to the top.
 */
const StepHeader = ({ id, title, subtitle, icon, center = false, display = false }) => {
    const headingRef = useRef(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (headingRef.current) {
            headingRef.current.focus({ preventScroll: true });
        }
    }, []);

    return (
        <Header center={center}>
            {icon}
            <Title id={id} ref={headingRef} tabIndex={-1} isDisplay={display}>
                {title}
            </Title>
            {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </Header>
    );
};

export default StepHeader;
